module.exports = __webpack_public_path__ + "media/images/projects-269415ca70c4564b2ff1aafd6a76ce1b.jpg";